import { IconLoading02 } from '@/components/icons'

const Loading = () => <div className="w-full h-full bg-primary-700 flex justify-center items-center">
    <IconLoading02 className="stroke-white animate-spin" size="xxl"/>
</div>

export default Loading
